import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import api from "../lib/api";
import { ui, SECTION_TAG_LABELS } from "../lib/ui";

export default function HotTopics() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/reports/trending", { params: { days: 30, limit: 6 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-8" data-testid="home-hot-topics">
      <div className={ui.card + " p-5 sm:p-6 border-[#8B1A1A]/15"}>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Flame size={18} className="text-[#8B1A1A]" />
            <h2 className="font-serif text-lg sm:text-xl font-semibold text-[#8B1A1A]">Hot this month</h2>
          </div>
          <Link to="/archive" className="text-sm text-[#8B1A1A] hover:underline inline-flex items-center gap-1">
            Browse all <ArrowRight size={13} />
          </Link>
        </div>
        <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1" data-testid="home-hot-topics-strip">
          {items.map((it, i) => (
            <Link
              key={i}
              to={`/section/${it.code}`}
              className="group shrink-0 w-64 rounded-xl border border-[#E8DCC8] bg-[#FFFDF9] hover:bg-[#F5F0E8] hover:border-[#8B1A1A]/30 px-4 py-3 transition-colors duration-150"
              data-testid="home-hot-topic-card"
            >
              <div className="flex items-center justify-between mb-1.5">
                <span className={ui.pill}>{SECTION_TAG_LABELS[it.code] || it.label}</span>
                <span className="inline-flex items-center gap-1 bg-[#8B1A1A] text-[#F5EAE0] text-xs font-semibold px-2 py-0.5 rounded-full">
                  <Flame size={11} /> {it.count}×
                </span>
              </div>
              <p className="text-[#210201] text-sm leading-snug line-clamp-2 group-hover:text-[#671813]">{it.topic}</p>
            </Link>
          ))}
        </div>
        <p className="text-xs text-[#5A4441] mt-3">Topics reported by multiple candidates in the last 30 days.</p>
      </div>
    </section>
  );
}
